import { ParticipationHeaderProps } from "./../types";
import { useAnalyticsHeaderProps } from "./useAnalyticsHeaderProps";
import { HeaderAnalytics } from "../../../../components/header-analytics";

export function AnalyticsHeaderWrapper(props: ParticipationHeaderProps) {
  const headerProps = useAnalyticsHeaderProps(props);
  return <HeaderAnalytics {...headerProps} />;
}
